import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "content"]

  static values = {
    current: { type: String, default: "production" },
    storageKey: { type: String, default: "devops_dashboard_environment" }
  }

  connect() {
    // Restore from localStorage
    const stored = localStorage.getItem(this.storageKeyValue)
    if (stored && ["production", "staging", "development"].includes(stored)) {
      this.currentValue = stored
    }

    this.updateUI()
  }

  select(event) {
    const environment = event.currentTarget.dataset.environment
    if (environment === this.currentValue) return

    this.currentValue = environment
    localStorage.setItem(this.storageKeyValue, environment)
    this.updateUI()

    // Dispatch custom event for other controllers to react
    this.dispatch("change", { detail: { environment } })

    // Update URL if Turbo is available
    if (window.Turbo) {
      const url = new URL(window.location)
      url.searchParams.set("environment", environment)
      window.Turbo.visit(url.toString(), { action: "replace" })
    }
  }

  updateUI() {
    this.buttonTargets.forEach(button => {
      const env = button.dataset.environment
      const isActive = env === this.currentValue

      button.classList.toggle("bg-indigo-600", isActive)
      button.classList.toggle("text-white", isActive)
      button.classList.toggle("bg-gray-100", !isActive)
      button.classList.toggle("text-gray-700", !isActive)
      button.setAttribute("aria-pressed", isActive)
    })

    // Show/hide content sections if they exist
    this.contentTargets.forEach(content => {
      const env = content.dataset.environment
      content.classList.toggle("hidden", env !== this.currentValue)
    })
  }

  // Keyboard shortcut handlers (called from keyboard_shortcuts_controller)
  selectProduction() {
    this.currentValue = "production"
    localStorage.setItem(this.storageKeyValue, "production")
    this.updateUI()
    this.dispatch("change", { detail: { environment: "production" } })
  }

  selectStaging() {
    this.currentValue = "staging"
    localStorage.setItem(this.storageKeyValue, "staging")
    this.updateUI()
    this.dispatch("change", { detail: { environment: "staging" } })
  }

  selectDevelopment() {
    this.currentValue = "development"
    localStorage.setItem(this.storageKeyValue, "development")
    this.updateUI()
    this.dispatch("change", { detail: { environment: "development" } })
  }
}
